import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import queryString from 'query-string';
import Select from 'react-select';
import * as formActions from 'shared/actions/searchForm';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toLocalized } from '../../../../../shared/helpers/locale';
import history from '../../../../../history';
import s from './SortLine.css';

class SortLine extends React.Component {
  static propTypes = {
    selectedActions: PropTypes.shape().isRequired,
    formVocabulary: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    locale: PropTypes.string.isRequired,
    type: PropTypes.string,
    //
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    type: 'default',
  };

  handleOrderingChange = ordering => {
    this.props.selectedActions.set.ordering(ordering);
    this.updateSearch('ordering', ordering.id);
  };

  handlePeriodChange = period => {
    this.props.selectedActions.set.period(period);
    this.updateSearch('period', period.id, true);
  };

  updateSearch = (param, value, resetPage = false) => {
    const { locale } = this.props;
    const { search, pathname } = history.location;
    const query = {
      ...queryString.parse(search),
      [param]: value,
    };
    if (resetPage) {
      query.page = 1;
    }
    const url = `${pathname}?${queryString.stringify(query)}`;

    history.push(toLocalized(url, locale));
  };

  handleWarrantyToggle = () => {
    const { formState, selectedActions } = this.props;
    const warranty = formState.usedWarranty ? null : true;

    selectedActions.set.usedWarranty(warranty);
    this.updateSearch('usedWarranty', warranty);
  };

  render() {
    const { formVocabulary, formState, type, intl } = this.props;
    const ordering = formVocabulary ? formVocabulary.ordering[type] : [];
    const periods = formVocabulary ? formVocabulary.periods : [];
    const formattedOrdering = ordering.map(({ title, ...props }) => ({
      ...props,
      title: intl.formatMessage({ id: title }),
    }));
    const formattedPeriods = periods.map(({ title, ...props }) => ({
      ...props,
      title: intl.formatMessage({ id: title }),
    }));

    const selectedOrdering =
      formState.ordering && formState.ordering.title === ordering[0].title
        ? { title: intl.formatMessage({ id: `${formState.ordering.title}` }) }
        : formState.ordering;

    const selectedPeriod =
      formState.period && formState.period.title === periods[0].title
        ? { title: intl.formatMessage({ id: `${formState.period.title}` }) }
        : formState.period;

    const { transport, isNew } = formState;
    const isAuto = transport && transport.slug === 'avto';

    return (
      <div className={s.root}>
        <div className={s.flexRow}>
          <div className={s.flexColumn}>
            <div className={s.select}>
              <Select
                instanceId="ordering-ff"
                name="ordering"
                options={formattedOrdering}
                labelKey="title"
                valueKey="id"
                searchable={false}
                clearable={false}
                onChange={this.handleOrderingChange}
                value={selectedOrdering}
              />
            </div>
            <div className={s.select}>
              <Select
                instanceId="period-ff"
                name="period"
                options={formattedPeriods}
                labelKey="title"
                valueKey="id"
                searchable={false}
                clearable={false}
                onChange={this.handlePeriodChange}
                value={selectedPeriod}
              />
            </div>
            {isAuto && !isNew && (
              <div className={s.checkboxContainer}>
                <label className={s.checkbox}>
                  <input
                    type="checkbox"
                    onChange={this.handleWarrantyToggle}
                    checked={!!formState.usedWarranty}
                  />{' '}
                  <FormattedMessage id="Б/у с гарантией" />
                </label>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ searchForm, globals }) => ({
  formState: searchForm && searchForm.selected,
  formVocabulary: searchForm && searchForm.vocabulary,
  locale: globals.locale,
});

const mapDispatchToProps = dispatch => ({
  selectedActions: {
    set: bindActionCreators(
      {
        ...formActions.selectedActions.set,
        ...formActions.carSetThunks,
      },
      dispatch,
    ),
  },
});

export default withStyles(s)(connect(mapStateToProps, mapDispatchToProps)(injectIntl(SortLine)));



// WEBPACK FOOTER //
// ./src/desktop/routes/search/components/SortLine/SortLine.js